import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CreateCompsTableComponent } from "./create-comps-table/create-comps-table.component";
import { RouterModule, Routes } from "@angular/router";
import { AuditFormulaComponent } from "./audit-formula/audit-formula.component";
import { GlobalHeaderModule } from "../global-header/global-header.module";
import { GlobalSubheaderModule } from "../global-subheader/global-subheader.module";
import { XlCustomConsensusComponent } from "./xl-custom-consensus/xl-custom-consensus.component";
import { CustomConsensusModule } from "../custom-consensus/custom-consensus.module";
import { FormsModule } from "@angular/forms";
import { IconsModule } from "@va/core-library/icons";
import { SharedModule } from "../shared/shared.module";
import { XLChartCarouselComponent } from "./xl-chart-carousel/xl-chart-carousel.component";
import { ChartPlotterModule } from "../chart-plotter/chart-plotter.module";
import { GlobalUserSettingsWrapperComponent } from "./global-user-settings-wrapper/global-user-settings-wrapper.component";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzCarouselModule } from "ng-zorro-antd/carousel";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { XlTemplateLibraryComponent } from "../shared/xl-template-library/xl-template-library.component";

const addinRoutes: Routes = [
  {
    path: "createcomps",
    component: CreateCompsTableComponent,
    data: {
      title: "Create Comps Table",
    },
  },
  {
    path: "auditformula",
    component: AuditFormulaComponent,
    data: {
      title: "Audit Formula",
    },
  },
  {
    path: "xlcustomconsensus",
    component: XlCustomConsensusComponent,
    data: {
      title: "Custom Consensus",
    },
  },
  {
    path: "chart-carousel",
    component: XLChartCarouselComponent,
    data: {
      title: "Chart",
    },
  },
  {
    path: "global-settings",
    component: GlobalUserSettingsWrapperComponent,
    data: {
      title: "Chart",
    },
  },
  {
    path: "template-library",
    component: XlTemplateLibraryComponent,
    data: {
      clientFacing: true,
      fromExcelAddin: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(addinRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class AddinPageRoutingModule {}

@NgModule({
  declarations: [
    CreateCompsTableComponent,
    AuditFormulaComponent,
    XlCustomConsensusComponent,
    XLChartCarouselComponent,
    GlobalUserSettingsWrapperComponent,
  ],
  imports: [
    CommonModule,
    AddinPageRoutingModule,
    GlobalSubheaderModule,
    CustomConsensusModule,
    FormsModule,
    IconsModule,
    ChartPlotterModule,
    GlobalHeaderModule,
    SharedModule,
    NzSelectModule,
    NzCarouselModule,
    NzButtonModule,
    NzInputModule,
    NzLayoutModule,
    NzCheckboxModule,
  ],
})
export class AddinPageModule {}
